export default "__VITE_ASSET__D3NiVLHo__"